import { computed, watch, type Ref } from 'vue'
import { useRpc } from '#storefront/composables'

const useProductPurchases = (productId: Ref<string | number>) => {
  const key = computed(() => `product-purchases-${productId.value.toString()}`)

  const { data, error, status, refresh } = useRpc(
    'getProductPurchases',
    key.value,
    () => ({
      productId: productId.value.toString(),
    }),
  )

  const fetching = computed(() => status.value === 'pending')

  // Watch productId changes to refresh purchases
  watch(
    productId,
    (newId, oldId) => {
      if (!newId || newId === oldId) {
        return
      }
      refresh()
    },
    { immediate: true },
  )

  const purchases = computed(() => data.value?.sales_count ?? 0)

  return {
    purchases,
    error,
    refresh,
    fetching,
  }
}

export default useProductPurchases
